module.exports = __webpack_public_path__ + "static/media/candor-coach-app-store-banner.26646c88.jpg";